import { Table } from '@vwfs-bronson/bronson-react';
import { AgentTemplate } from '../fes';

export function TemplatesTable({ templates }: { templates: AgentTemplate[] }) {
  if (templates.length === 0) {
    return <p className="app-empty">No templates found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {templates.map(template => (
            <Table.Tr key={template.templateId || template.name}>
              <Table.Td>{template.name}</Table.Td>
              <Table.Td>{template.description || '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
